import React from 'react';

import AsiaBureauChiefVideo from '@components/pages/AsiaTechCoverage/AsiaBureauChiefVideo';
import { Reporter } from '@utils/backend-api/subscribe';

import Carousel from './Carousel';

interface ExpertsProps {
  carouselClass?: string;
  reporters: Reporter[];
}

const Experts = ({ carouselClass, reporters }: ExpertsProps) => {
  return (
    <div className="mt-64 overflow-hidden px-16 sm:mt-96">
      <h2 className="m-0 text-center font-suisse-works text-headline-xs text-black md:text-headline-sm">
        For The Experts by The Experts
      </h2>
      <Carousel reporters={reporters} className={carouselClass} />
      <div className="mt-64 block sm:hidden">
        <AsiaBureauChiefVideo />
      </div>
    </div>
  );
};

export default Experts;
